import { routes } from "@/common/utils/routes";
import { useNavigate } from "react-router-dom";
import { nFormatter } from "@/common/utils/parseNumber";
import { ICreatorsItems } from "@/common/services/types";
import DefaultUserIcon from "@/common/images/icons/default_userpic.svg?react";
import ArrowIcon from "@/common/images/icons/arrow_top_right.svg?react";
import { VerifiedIcon } from "@/components/UI/VerifiedIcon";

import "./SearchCreator.scss";

interface IProps {
  itemData: ICreatorsItems;
  onClick: (value: string) => void;
}

export const SearchCreator = ({ itemData, onClick }: IProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClick(itemData.name);

    navigate(routes.user(itemData.text.substr(1)));
  };

  return (
    <li className="SearchCreator" onClick={handleClick}>
      {
        itemData.image ?
          <div className="SearchCreator-PersonIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
          : <div className="SearchCreator-PersonIcon SearchCreator-PersonIcon_isEmpty"><DefaultUserIcon /></div>
      }

      <div className="SearchCreator-Cnt">
        <h4>
          { itemData.name }
          { itemData.verified && <VerifiedIcon title={`Verified ${itemData.studio ? "studio" : "user"}`} isStudio={itemData.studio} />}
        </h4>
        <p>{itemData.text} | {nFormatter(itemData.followers)} <span>followers</span></p>
      </div>

      <ArrowIcon className="SearchCreator-Arrow" />
    </li>
  );
};
